import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function ReportCard({ title, subtitle, icon, onClick }) {
	return (
		<div className='text-link' onClick={onClick}>
			<Container>
				<div className="clearfix">
					<div className="float-left mr-2 mb-4">
						<FontAwesomeIcon icon={icon} className="icon" />
					</div>
					<div>
						<h6 className="mb-0">{title}</h6>
						<p className="mb-0 hint-text">{subtitle}</p>
					</div>
				</div>
			</Container>
		</div>
	)
}

const Container = styled.div`
	background-color: #fff;
	padding: 20px;
	border: 3px solid #fff;
	&:hover {
		cursor: pointer;
		background-color: #f8f8f8;
	}
	& .icon {
		font-size: 25px;
		color: #e42537;
	}
	p {
		color: #333;
	}
`